// 富文本 HTML 适配小程序 <rich-text> 的内联样式工具
// 背景：图文详情直接存富文本编辑器（wangEditor）产出的 HTML，小程序端用 <RichText nodes={detail}> 渲染。
// rich-text 内部不认外部 class，边框 / 宽度 / 内边距等必须写在标签的内联 style 上，故保存前统一补齐。
// 原则：只补缺失属性，编辑器已自带的样式（如 wangEditor 表格边框）不覆盖，避免破坏原有排版。

type Decl = { prop: string; css: string };

// 需要补齐内联样式的标签及其属性（prop 用于判断是否已存在，css 为补齐内容）
const RULES: Record<string, Decl[]> = {
  img: [
    { prop: 'max-width', css: 'max-width:100%;' },
    { prop: 'height', css: 'height:auto;' },
    { prop: 'display', css: 'display:block;margin:16rpx auto;' },
  ],
  table: [
    { prop: 'border-collapse', css: 'border-collapse:collapse;' },
    { prop: 'width', css: 'width:100%;' },
  ],
  td: [
    { prop: 'border', css: 'border:1px solid #e5e7eb;' },
    { prop: 'padding', css: 'padding:10rpx 12rpx;word-break:break-all;' },
  ],
  th: [
    { prop: 'border', css: 'border:1px solid #e5e7eb;' },
    { prop: 'padding', css: 'padding:10rpx 12rpx;word-break:break-all;' },
    { prop: 'background', css: 'background:#f9fafb;font-weight:bold;' },
  ],
};

// 给 img / table / td / th 补齐 rich-text 可用的内联样式
export const ensureRichTextSafe = (html?: string): string => {
  if (!html) return '';
  const tags = Object.keys(RULES).join('|');
  // 仅匹配开始标签；\b 保证 <th 不会误配 <thead、<td 不会误配 <tfoot
  const re = new RegExp(`<(${tags})\\b([^>]*)>`, 'gi');
  return html.replace(re, (m: string, tag: string, attrs: string) => {
    const rules = RULES[tag.toLowerCase()];
    if (!rules) return m;
    const sm = attrs.match(/\bstyle\s*=\s*(["'])([\s\S]*?)\1/i);
    const existing = sm ? sm[2] : '';
    const lower = existing.toLowerCase();
    const add = rules
      .filter((r) => !lower.includes(r.prop))
      .map((r) => r.css)
      .join('');
    if (!add) return m;
    const base = existing ? existing.replace(/;?\s*$/, '') + ';' : '';
    const newStyle = base + add.replace(/;$/, '');
    const newAttrs = sm ? attrs.replace(sm[0], `style="${newStyle}"`) : ` style="${newStyle}"${attrs}`;
    return `<${tag}${newAttrs}>`;
  });
};
